export default __webpack_public_path__ + "static/media/consulting.d022a99f.png";